module.exports = __webpack_public_path__ + "static/media/LK_White_Dashboard.f8167eeb.svg";